export default "__VITE_ASSET__S0MNHTc0__"